angular.module("Main").controller("BackToHomepageController", ["$stateParams", "SessionService", "BookingService",
    function ($stateParams, SessionService, BookingService) {
        var vm = this;


        if (_.isNil($stateParams.loginResponseNull) && _.isNil($stateParams.loginError) && _.isNil($stateParams.cid) && _.isNil($stateParams.main) ||
            ($stateParams.urlIncomplete==='1' && $stateParams.cid==='1' && $stateParams.loginResponseNull==='0' && $stateParams.loginError==='0' && $stateParams.main==='0')
        ) {
            vm.isFalseUrl = true
        } else {
            vm.isFalseUrl = false;
        }
        vm.loginResponseNull = $stateParams.loginResponseNull;
        vm.loginError = $stateParams.loginError;
        vm.clubId = $stateParams.cid;
        vm.urlIncomplete = $stateParams.urlIncomplete;
        vm.mainError = $stateParams.main;

            BookingService.loadClublink().then(function (config) {
                vm.clubUrl = config.link;
            });
        let clubId = $stateParams.cid;
        // if (_.isEmpty(clubId)) {
        //     SessionService.setAuthData(clubId);
        // }

    }]
);